import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { MarkAllNotificationsAsReadRequest } from './notifications.types'

const markAllNotificationsAsRead = async (
  request?: MarkAllNotificationsAsReadRequest,
): Promise<void> => {
  await apiClient.post('/v1/platform/notifications/all', request ?? {})
}

export const useMarkAllNotificationsAsRead = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (request?: MarkAllNotificationsAsReadRequest) =>
      markAllNotificationsAsRead(request),
    meta: {
      invalidatesQuery: ['notifications', 'notification-stats'],
      ...feedback,
    },
  })
}
